import Referrals from './src/referrals';

export default Referrals;
